<template>
	<div class="beta-history-data">
		<span class="beta-history-data__text-emphasized">
			{{ spanLabel }}
		</span>
		
		{{ textToDisplay }}

		<Button
			v-show="showButton"
			className="btn--inline-link"
			labelText="View full list"
			:btnClick="showCustomersModal"
		/>
	</div>
</template>

<script>
import Button from '@/components/forms/button/button';

export default {
	name: 'Featurestext',
	components: {
		Button
	},
	props: {
		spanLabel: {
			type: String,
			required: true
		},
		featuresText: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			textToDisplay: ''
		};
	},
	computed: {
		showButton() {
			return this.featuresText !== this.textToDisplay;
		}
	},
	methods: {
		showCustomersModal() {
			this.$emit('click', this.featuresText);
		}
	},
	watch: {
		featuresText: {
			immediate: true,
			handler(val) {
				let characterLength;
				if (this.screenSize.desktop) {
					characterLength = 60;
				} else {
					characterLength = 30;
				}

				if (val.length > characterLength) {
					this.textToDisplay =
						val.substring(0, characterLength) + '...';
					return;
				}

				this.textToDisplay = val;
			}
		}
	}
};
</script>

<style lang="scss">

/**
  * Beta Feature History Table - Customer List
  * Can use SCSS variables = TRUE
*/

.beta-history-data {
	&__text-emphasized {
		font-weight: $medium-font-weight;
	}
}
</style>
